import TitleInput from "Components/Common/Input/TextBoxes/TitleInput/TitleInput";
import MediaUpload from "Components/Common/MediaUpload/MediaUpload";
import PdfViewer from "Components/Common/PdfViewer/PdfViewer";
import Popover from "Components/Common/Popover/Popover";
import PopoverPane from "Components/Common/Popover/PopoverPane/PopoverPane";
import { TaskTemplateStep } from "Models/Tasks/TaskTemplateStep";
import * as React from "react";
import i18n from "Translations/i18n";

interface IProps {
    steps: TaskTemplateStep[];
    showStepsPopover: boolean;
    closePopover: () => void;
    onUpdate: (steps: TaskTemplateStep[], descriptionFileUrl?: string) => void;
    addStep: () => void;
    popoverPaneIndex: number;
    descriptionFileUrl?: string;
}

interface IState {
    steps: TaskTemplateStep[];
    showStepsPopover: boolean;
    popoverPaneIndex: number;
    descriptionFileUrl?: string;
    addItemText: string;
}

export class TaskTemplateStepsPopover extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            steps: props.steps,
            showStepsPopover: props.showStepsPopover,
            popoverPaneIndex: props.popoverPaneIndex,
            descriptionFileUrl: props.descriptionFileUrl,
            addItemText: props.descriptionFileUrl ? "" : i18n.t("common.addStep")
        };

        this.onDescriptionChanged = this.onDescriptionChanged.bind(this);
        this.onMediaChanged = this.onMediaChanged.bind(this);
        this.deleteStep = this.deleteStep.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (prevState.showStepsPopover !== nextProps.showStepsPopover
            || prevState.popoverPaneIndex !== nextProps.popoverPaneIndex) {
            partialState.showStepsPopover = !!nextProps.showStepsPopover;
            partialState.popoverPaneIndex = nextProps.popoverPaneIndex;
            partialState.addItemText = nextProps.descriptionFileUrl ? "" : i18n.t("common.addStep");
            partialState.descriptionFileUrl = nextProps.descriptionFileUrl;
        }

        if (nextProps.steps && nextProps.steps !== prevState.steps) {
            partialState.steps = nextProps.steps;
        }

        return partialState;
    }

    public onDescriptionChanged(stepIndex: number, newValue: string) {
        const steps = [...this.state.steps];
        steps[stepIndex] = { ...steps[stepIndex], description: newValue };
        this.setState({ steps });
        this.props.onUpdate(steps, undefined);
    }

    public onMediaChanged(stepIndex: number, state: { imageFile?: File, videoFile?: File, videoThumbnailFile?: File }) {
        const steps = [...this.state.steps];
        steps[stepIndex] = {
            ...steps[stepIndex],
            pictureUrl: state.imageFile ? URL.createObjectURL(state.imageFile) : undefined,
            videoUrl: state.videoFile ? state.videoFile !== steps[stepIndex].videoFile ? URL.createObjectURL(state.videoFile) : steps[stepIndex].videoUrl : state.videoThumbnailFile ? steps[stepIndex].videoUrl : undefined,
            videoThumbnailUrl: state.videoThumbnailFile ? URL.createObjectURL(state.videoThumbnailFile) : undefined,
            pictureFile: state.imageFile,
            videoFile: state.videoFile,
            videoThumbnailFile: state.videoThumbnailFile
        };
        this.setState({ steps });
        this.props.onUpdate(steps, undefined);
    }

    public deleteStep(stepNumber: number) {
        if (this.state.descriptionFileUrl) {
            this.setState({
                descriptionFileUrl: undefined
            });

            this.props.onUpdate(this.state.steps, undefined);
        }
        else {
            const localSteps = this.state.steps;
            localSteps.splice(stepNumber - 1, 1);
            const paneIndex = localSteps.length - 1;

            this.setState({
                steps: localSteps,
                showStepsPopover: true,
                popoverPaneIndex: paneIndex
            });

            this.props.onUpdate(localSteps, undefined);
        }
    }

    public render() {
        return (
            <Popover
                id="pprTaskTemplateSteps"
                title={i18n.t("common.step")}
                isOpen={this.state.showStepsPopover}
                onClose={this.props.closePopover}
                paneIndex={this.state.popoverPaneIndex}
                addChild={this.props.addStep}
                deleteChild={this.deleteStep}
                addItemText={this.state.addItemText}
            >
                {
                    this.state.steps && this.state.steps.length > 0 ? (
                        this.state.steps.map((step, stepIndex) => (
                            <PopoverPane key={stepIndex}>
                                <MediaUpload
                                    id="mduTaskTemplateStep"
                                    imageUrl={step.pictureUrl}
                                    videoUrl={step.videoUrl}
                                    videoThumbnailUrl={step.videoThumbnailUrl}
                                    onChange={(state) => this.onMediaChanged(stepIndex, state)}
                                />
                                <TitleInput id="txtTaskTemplateStepDescription" value={step.description} maxHeight={200} onChange={(newValue) => this.onDescriptionChanged(stepIndex, newValue)} />
                            </PopoverPane>
                        ))
                    ) : this.state.descriptionFileUrl && (
                        <PopoverPane>
                            <PdfViewer src={this.state.descriptionFileUrl} />
                        </PopoverPane>
                    )
                }
            </Popover>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateDetailView/TaskTemplateSteps/TaskTemplateStepsPopover/TaskTemplateStepsPopover.tsx